import { graphql } from '@apollo/client/react/hoc'

import { ApplicationError, NotFoundError } from '../../helpers/errors'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ slug, country }) => ({
  context: { version: 2 },
  variables: {
    slug,
    country,
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = props => {
  if (props.error) {
    return {
      error: new ApplicationError(props.error),
    }
  } else if (props.loading) {
    return { loading: props.loading }
  } else if (!props.data?.cfCentreCollection?.items?.[0]) {
    // Centre is not known
    return {
      error: new NotFoundError(),
    }
  }

  const centre = props.data.cfCentreCollection.items[0]

  let navigationMenu = null

  // Following the semantics here from `../with-centre` where the navigation is
  // set to `null` if the centre is closed, which seems... weird, but in the
  // interest of not toppling the house of cards, I'll leave it as-is until
  // after WEVO is launched ¯\_(ツ)_/¯
  if (['Open', 'Opening Soon'].includes(centre.status)) {
    try {
      navigationMenu = centre.navigationMenu
    } catch {} // eslint-disable-line no-empty
  }

  return {
    centre: {
      ...centre,
      navigationMenu,
    },
  }
}

const withCentreNav = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withCentreNav
